const growth =
    <>
        <p>
            One of my earliest memories is set in 2004 rural Philippines in the bedroom I shared with my
            mother. I recall telling her a story about how I received less than perfect marks on a spelling test because
            I spelled “love” incorrectly as “loev.”
            <br />
            <br />
            <em>You know how you can’t even hear the ‘e’ sound? That’s why I thought it was in the middle!</em>
            <br />
            <br />
            I remember feeling like a stand-up comedian at her first show, awkwardly trying to solicit laughs from my
            audience. I wanted to make sure that she didn’t coddle me about my faux pas. Like when a baby hits its head
            and only cries once you make a face suggesting that it’d just hurt itself — I knew that I would start to
            regret my misspelling once my mom showed pity toward me.
            <br />
            <br />
            <em>It’s okay that I made that mistake, right, Mom? Because I’m still young? I have my whole life ahead to
                learn and grow, so long as I study well!</em>
            <br />
            <br />
            I wish I could remember why I said that. Maybe I heard that sentiment from one of my
            instructors and co-opted it as my own, as children do. Or perhaps I really was just wiser as a
            five-year-old than I am now.
            <br />
            <br />
            I don’t know what makes me doubt my capacity for growth these days, but it sure does manifest a great
            departure from my feelings as a toddler all those years ago. I’ve realized that I’m often put off by the
            first mistake I make when I attempt a new hobby or new technology. I’m still learning how to overcome this
            shortcoming, and I think my recent work communicates how much I prioritize this task. I’ve been honing new
            technical skills that I’ve previously avoided because of bad request errors and trying new crochet patterns
            with the tenacity to start over when needed.
            <br />
            <br />
            What had been intrinsic to me in the past is something I need to work a little bit harder to internalize
            today — one is guaranteed to learn when one approaches life with commitment. Just as I had pushed past my
            initial blunder and eventually learned how to properly spell “love,” I trust that I’ll someday soundly
            crochet a sweater or code a Leetcode solution on first pass (hah). I simply need to keep at it, whatever “it’ is,
            and carry Toddler Mariel’s wisdom with me in all my endeavors.
        </p>
    </>;

export default growth;